import {
  fromJS,
  Map
}                           from 'immutable';
import _invariant           from 'invariant';
import { handleActions }    from 'redux-actions';
import url                  from '../../../../utils/url';
import { buildListActions } from '../../../../actions/utils/apiResources/buildSyncActions';


const DATA_KEY_HYDRA_VIEW = 'hydra:view';
const DATA_KEY_HYDRA_LAST = 'hydra:last';


/**
 * @todo TESTS: Add all tests
 *
 * @param {string} resourceName
 */
const buildPageCountsReducer = (resourceName) => {

  const listLoadSuccess = buildListActions(resourceName).success;

  return handleActions(
    {

      [listLoadSuccess]: (state, {payload: {receivedData}}) => {

        _invariant(receivedData, 'Missing receivedData');

        const data = fromJS(receivedData);

        const urlString = data.getIn([DATA_KEY_HYDRA_VIEW, '@id']) || data.get('@id');

        const urlWithoutPageParam = url.removeQueryParams(urlString, {page: true})

        // Strip any trailing '?'
          .replace(/\?$/, '');

        const lastPageUrl = data.getIn([DATA_KEY_HYDRA_VIEW, DATA_KEY_HYDRA_LAST]) || null;

        const lastPage = (lastPageUrl && Number(url.parse(lastPageUrl, true).query.page)) || 1;

        return state.set(urlWithoutPageParam, lastPage);

      },

    },

    Map()
  );

};

export default buildPageCountsReducer;


// WEBPACK FOOTER //
// ./src/reducers/utils/apiResources/list/buildPageCountsReducer.js